import createLightTheme from '@nykaa/ui-components/themes/lightTheme/createLightTheme';
import { Theme } from '@nykaa/ui-components/themes/types';
import { theme as lightTokens } from 'shared/styles/theme/fashionTheme';
import { config as darkTokens } from 'shared/styles/theme/darkTheme';
import { theme as footlockerTokens } from 'shared/styles/theme/footlockerTheme';

const themeMap = {
  light: {
    tokens: lightTokens,
    componentTokens: {
      reviewCTA: {
        background: 'transparent',
        color: '#1a1a1a',
        border: '1px solid rgba(0,0,0,0.16)',
      },
    },
  },
  dark: {
    tokens: darkTokens,
    componentTokens: {
      reviewCTA: {
        background: '#ffffff',
        color: '#000000',
        border: 'none',
      },
    },
  },
  footlocker: {
    tokens: footlockerTokens,
    componentTokens: {
      reviewCTA: {
        background: 'transparent',
        color: '#000000',
        border: '1px solid rgba(0,0,0,0.16)',
      },
    },
  },
};

export const getAppTheme = (themeName?: string): Theme => {
  const entry =
    themeMap[process.env.DOMAIN_NAME as keyof typeof themeMap] ??
    themeMap[themeName as keyof typeof themeMap] ??
    themeMap.light;

  // @ts-expect-error - buttonBorderRadius is a custom property not in UI components Borders type
  const theme = createLightTheme(entry.tokens);

  // @ts-expect-error - componentTokens is a custom extension not present in the Theme type
  return { ...theme, componentTokens: entry.componentTokens };
};
